import { Component } from "@angular/core";

@Component({
  selector: "brd-contact-support",
  templateUrl: "./contact-support.component.html",
  styleUrl: "./contact-support.component.less",
  standalone: false
})
export class ContactSupportComponent {}
